import { ReadArticlesManager } from '../ts/components/zork/readArticlesManager';
/**
 * Default hook for the ARTICLE_SERIES page type.
 *
 * Updates the series articles read-state indicators in the UI.
 *
 * To override, create: projects/<id>/ui/hooks/onArticleSeries.ts
 */
export default async function onArticleSeries(context) {
    const { currentArticleId } = context;
    const readArticlesManager = new ReadArticlesManager(currentArticleId);
    readArticlesManager.updateSeriesArticlesUI(false);
}
